import { DEFAULT_RUN_LIST_FILTERS, type RunListFilters } from "../../types";

export function hasActiveFilters(filters: RunListFilters): boolean {
  return countActiveFilters(filters) > 0;
}

export function countActiveFilters(filters: RunListFilters): number {
  let count = 0;
  if (
    filters.sortBy !== DEFAULT_RUN_LIST_FILTERS.sortBy ||
    filters.sortDirection !== DEFAULT_RUN_LIST_FILTERS.sortDirection
  ) {
    count += 1;
  }
  count += filters.status.length;
  if (filters.dateFrom) count += 1;
  if (filters.dateTo) count += 1;
  return count;
}
